import { jsx as C } from "react/jsx-runtime";
const r = ({ size: L = 24, className: t, thin: o, fill: e }) => /* @__PURE__ */ C(
  "svg",
  {
    className: t,
    width: L,
    height: L,
    viewBox: o ? "0 0 28 27" : "0 0 36 35",
    fill: e || "none",
    children: o ? /* @__PURE__ */ C("path", { d: "M14.5245 1.59146C14.6741 1.1308 15.3259 1.1308 15.4755 1.59145L18.2555 10.1472C18.3224 10.3532 18.5144 10.4927 18.731 10.4927H27.727C28.2114 10.4927 28.4128 11.1125 28.0209 11.3972L20.743 16.6849C20.5677 16.8122 20.4944 17.0379 20.5613 17.2439L23.3413 25.7997C23.4909 26.2603 22.9637 26.6434 22.5718 26.3587L15.2939 21.0709C15.1186 20.9436 14.8814 20.9436 14.7061 21.0709L7.42817 26.3587C7.03631 26.6434 6.50907 26.2603 6.65875 25.7997L9.43867 17.2439C9.50561 17.0379 9.43228 16.8122 9.25704 16.6849L1.9791 11.3972C1.58725 11.1125 1.78863 10.4927 2.27299 10.4927H11.269C11.4856 10.4927 11.6776 10.3532 11.7445 10.1472L14.5245 1.59146Z" }) : /* @__PURE__ */ C(
      "path",
      {
        d: "M17.0841 1.09048C17.4338 0.292232 18.5662 0.292233 18.9159 1.09048L23.2315 10.9401C23.3766 11.2712 23.6891 11.4982 24.0488 11.5339L34.7499 12.5945C35.6172 12.6805 35.9671 13.7575 35.316 14.3368L27.2821 21.4848C27.012 21.7251 26.8926 22.0925 26.9699 22.4456L29.268 32.9507C29.4542 33.8021 28.5381 34.4677 27.7859 34.0275L18.5051 28.5956C18.1931 28.413 17.8069 28.413 17.4949 28.5956L8.21406 34.0275C7.46191 34.4677 6.54579 33.8021 6.73204 32.9507L9.0301 22.4456C9.10735 22.0925 8.98799 21.7251 8.71792 21.4848L0.68399 14.3368C0.0328937 13.7575 0.382819 12.6805 1.25007 12.5945L11.9512 11.5339C12.3109 11.4982 12.6234 11.2712 12.7685 10.9401L17.0841 1.09048Z",
        stroke: "none",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  r as StarIcon
};
